import { DirectiveOptions, DirectiveFunction, VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options.d';
import Intersect from './Intersect';

const intersectMap: Map<HTMLElement, Intersect> = new Map<HTMLElement, Intersect>();

/**
 *
 */
const bind: DirectiveFunction = (el: HTMLElement, binding: DirectiveBinding, vnode: VNode) => {
  if (vnode.context) {
    const intersect = new Intersect(vnode.context);
    intersectMap.set(el, intersect);
    intersect.bind(el, binding);
  }
};

/**
 *
 */
const unbind: DirectiveFunction = (el: HTMLElement) => {
  const localIntersect = intersectMap.get(el);
  if (localIntersect) {
    localIntersect.unbind(el);
  }
};

/**
 *
 */
const Index: DirectiveOptions = {
  bind,
  unbind,
};

export default Index;
